export default "__VITE_ASSET__02e431fc__"